import { render, staticRenderFns } from "./PerksBanner.vue?vue&type=template&id=b2f3a89a&"
import script from "./PerksBanner.vue?vue&type=script&lang=ts&"
export * from "./PerksBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports